import React from 'react';

import ReactDOM from 'react-dom';
import {
	Button,
	Collapse,
	CollapseItem
} from 'element-react';

 

import KeeVue from '../base/KeeVue.js'

import FsResizeBtn from './FsResizeBtn.js'

import $ from 'jquery';


export default class FsResizers extends KeeVue {
	constructor(props) {
		super(props);

		this.state = {
			moveDirect: '',
			point: {
				x: 0,
				y: 0,
			},
			currentScale: 100,
			component: null,
		}

	}

	componentWillMount() {}

	renderItem=(item,index)=>{
		if(item.isSelected&&item.style.position==='absolute')
		{
			var childDom = null ;
			if(item.child&&item.child.length>0)
			{
				childDom = item.child.map((item2,index2)=>{
					return this.renderItem(item2,index2);
				})
			}
			return <div key={index}><FsResizeBtn component={item}></FsResizeBtn>
			{childDom}</div>
		}
	}
	

	render() {
		return <div tag="resizers"  >
		{
			this.props.components&&this.props.components.map((item,index)=>{
				return this.renderItem(item,index);
			})
		}
		</div>;
	}
}
